import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const FetchApiContext = createContext({});
export function FetchApiProvider({ children, ...props }) {
    return (_jsx(FetchApiContext.Provider, { value: props, children: children }));
}
